import { useState } from "react";
import { Link } from "react-router-dom";
import { Accordion, Dropdown, NavLink } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updatePaymentLocation } from "../redux/slice/paymentLocations";
import logo from "../assets/img/logo.png";
import people5 from "../assets/img/people/people-5.jpg";
import { updateSearchedData } from "../redux/slice/searchData";
import {
  viewFindAccount,
  viewHouse,
  viewAccounts,
  viewBills,
  viewPayments,
  viewTransfers,
  viewDisbursements,
  viewReports,
  viewCollectionAccounts,
  viewUsers,
  viewRoles,
  viewAgents,
  viewGroups,
  viewReconciliation,
  viewComplaints,
  viewPendingAccountsApproval,
  viewDashboard,
  viewAdminPanel,
  viewTopDashboard,
  viewSupportMenu,
  viewTopLevelDisbursement,
  viewRevenueAssuarance,
  viewAudits
} from "../utils/roles";
export function LoggedinHome({ children }) {
  const [show, setShow] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const roles = JSON.parse(localStorage.getItem("roles"));
  const location = JSON.parse(localStorage.getItem("locations"));
  const locationId = location[0].id;
  const [toggle, setToggle] = useState(true);
  const navToggle = () => {
    document.getElementById("body").classList.toggle("ms-aside-left-open");
    document.getElementById("ms-side-nav").classList.toggle("ms-aside-open");
    document.getElementById("overlayleft").classList.toggle("d-block");
  };
  const dispatch = useDispatch();
  const logout = () => {
    localStorage.clear();
    dispatch(updatePaymentLocation([]));
    dispatch(updateSearchedData([]));
  };
  return (
    <div>
      {/* Sidenav */}
      <div
        className='body ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar'
        id='body'
      >
        <div>
          {/* Overlays */}
          <div
            className='ms-aside-overlay ms-overlay-left ms-toggler'
            id='overlayleft'
            data-target='#ms-side-nav'
            data-toggle='slideLeft'
            onClick={navToggle}
          />
          {/* Sidebar Navigation Left */}
          <div
            id='ms-side-nav'
            className='side-nav fixed ms-aside-scrollable ms-aside-left side-Nav-Bg'
            style={{
              overflowY: "auto",
              zIndex: 2000,
              position: "fixed",
              top: 0,
              bottom: 0,
            }}
          >
            {/* Logo */}
            <div className='logo-sn ms-d-block-lg'>
              <Link className='pl-0 ml-0 text-center side-Nav-Bg' to=''>
                {" "}
                <img src={logo} alt='logo' />{" "}
              </Link>
            </div>
            {/* Navigation */}
            <Accordion
              defaultActiveKey='0'
              className='accordion ms-main-aside fs-14'
              id='side-nav-accordion'
            >
              {roles.some((role) => role.id === viewDashboard) && (
                <li className='menu-item'>
                  <Link to='/loggedin/low-level-dashboard'>
                    <span>
                      <i className='material-icons fs-16'>dashboard</i>Dashboard
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewTopDashboard) && (
                <li className='menu-item'>
                  <Link to='/loggedin/top-level-dashboard'>
                    <span>
                      <i className='material-icons fs-16'>dashboard</i>Dashboard
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewSupportMenu) && (
                <li className='menu-item'>
                  <Link to='/loggedin/support'>
                    <span>
                      <i className='material-icons fs-16'>contact_support</i>
                      Support
                    </span>
                  </Link>
                </li>
              )}
              <li className='menu-item'>
                <Link to='/loggedin/videos'>
                  <span>
                    <i className='material-icons fs-16'>videocam</i>
                    Videos
                  </span>
                </Link>
              </li>
              {roles.some((role) => role.id === viewFindAccount) && (
                <li className='menu-item'>
                  <Link to='/loggedin/search-accounts'>
                    <span>
                      <i className='material-icons fs-16'>search</i>Find Account
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewHouse) && (
                <li className='menu-item'>
                  <Link to='/loggedin/houses'>
                    <span>
                      <i className='material-icons fs-16'>home</i>Houses
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewAccounts) && (
                <li className='menu-item'>
                  <Link to='/loggedin/accounts'>
                    <span>
                      <i className='material-icons fs-16'>assignment_ind</i>
                      Accounts
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewBills) && (
                <li className='menu-item'>
                  <Link to='/loggedin/bills'>
                    <span>
                      <i className='material-icons fs-16'>payment</i>Bills
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewPayments) && (
                <li className='menu-item'>
                  <Link to='/loggedin/payments'>
                    <span>
                      <i className='material-icons fs-16'>
                        account_balance_wallet
                      </i>
                      Payments
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewTransfers) && (
                <li className='menu-item'>
                  <Link to='/loggedin/transfers'>
                    <span>
                      <i className='material-icons fs-16'>cached</i>
                      Transfers
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewDisbursements) && (
                <li className='menu-item'>
                  <Link to='/loggedin/disbursement'>
                    <span>
                      <i className='material-icons fs-16'>person</i>
                      Beneficiary
                    </span>
                  </Link>
                </li>
              )}
              {roles.some((role) => role.id === viewReports) && (
                <Accordion defaultActiveKey='1'>
                  <li className='menu-item'>
                    <Accordion.Toggle
                      as={NavLink}
                      variant='link'
                      eventKey='0'
                      className='has-chevron'
                    >
                      <span>
                        <i className='material-icons fs-16'>assignment</i>
                        Reports{" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey='0'>
                      <ul
                        id='dashboard'
                        aria-labelledby='dashboard'
                        data-parent='#side-nav-accordion'
                      >
                        <li>
                          {" "}
                          <Link to='/loggedin/monthly-report'>
                            Monthly Collections
                          </Link>{" "}
                        </li>
                        <li>
                          {" "}
                          <Link to='/loggedin/collection-report'>
                            {" "}
                            Daily Collections{" "}
                          </Link>{" "}
                        </li>
                        <li>
                          {" "}
                          <Link to='/loggedin/houses-report'>
                            Monthly Houses
                          </Link>{" "}
                        </li>
                        <li>
                          {" "}
                          <Link to='/loggedin/accounts-report'>
                            Accounts Report
                          </Link>{" "}
                        </li>
                      </ul>
                    </Accordion.Collapse>
                  </li>
                </Accordion>
              )}
              {roles.some((role) => role.id === viewRevenueAssuarance) && (
                <Accordion defaultActiveKey='1'>
                  <li className='menu-item'>
                    <Accordion.Toggle
                      as={NavLink}
                      variant='link'
                      eventKey='0'
                      className='has-chevron'
                    >
                      <span>
                        <i className='material-icons fs-16'>payment</i>
                        Revenue Assurance{" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey='0'>
                      <ul
                        id='dashboard'
                        aria-labelledby='dashboard'
                        data-parent='#side-nav-accordion'
                      >
                        {roles.some(
                          (role) => role.id === viewReconciliation
                        ) && (
                          <li className='menu-item'>
                            <Link to='/loggedin/reconciliation'>
                              <span>Reconciliation</span>
                            </Link>
                          </li>
                        )}
                        {roles.some(
                          (role) => role.id === viewTopLevelDisbursement
                        ) && (
                          <li className='menu-item'>
                            <Link to='/loggedin/top-level-disbursement'>
                              <span>Disbursement</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    </Accordion.Collapse>
                  </li>
                </Accordion>
              )}
              {roles.some(
                (role) => role.id === viewPendingAccountsApproval
              ) && (
                <Accordion defaultActiveKey='1'>
                  <li className='menu-item'>
                    <Accordion.Toggle
                      as={NavLink}
                      variant='link'
                      eventKey='0'
                      className='has-chevron'
                    >
                      <span>
                        <i className='material-icons fs-16'>assignment_ind</i>
                        Collection Management{" "}
                      </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey='0'>
                      <ul
                        id='dashboard'
                        aria-labelledby='dashboard'
                        data-parent='#side-nav-accordion'
                      >
                        <li>
                          {" "}
                          <Link to='/loggedin/account-pending-approval'>
                            Pending accounts
                          </Link>{" "}
                        </li>
                      </ul>
                    </Accordion.Collapse>
                  </li>
                </Accordion>
              )}
              <Accordion defaultActiveKey='1'>
                <li className='menu-item'>
                  {roles?.some((role) => role.id === viewAdminPanel) && (
                    <Accordion.Toggle
                      as={NavLink}
                      variant='link'
                      eventKey='0'
                      className='has-chevron'
                      // onClick={refetch}
                    >
                      <span>
                        <i className='material-icons fs-16'>
                          admin_panel_settings
                        </i>
                        Admin{" "}
                      </span>
                    </Accordion.Toggle>
                  )}
                  <Accordion.Collapse eventKey='0'>
                    <ul
                      id='users'
                      aria-labelledby='users'
                      data-parent='#side-nav-accordion'
                    >
                      {roles.some(
                        (role) => role.id === viewAudits
                      ) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/audit-logs'>
                            {" "}
                            Audit Logs
                          </Link>{" "}
                        </li>
                      )}
                      {roles.some(
                        (role) => role.id === viewCollectionAccounts
                      ) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/collection-accounts'>
                            {" "}
                            Collection Account
                          </Link>{" "}
                        </li>
                      )}
                      <div className='d-flex justify-content-between'>
                        {roles.some((role) => role.id === viewComplaints) && (
                          <li>
                            {" "}
                            <Link to='/loggedin/admin/complaints'>
                              {" "}
                              Complaints
                            </Link>{" "}
                          </li>
                        )}
                        {/* {complaints?.some(
                          (complaint) => complaint.status.id === 0
                        ) &&
                          roles.some((role) => role.id === viewComplaints) && (
                            <div
                              className='mr-2 mt-3'
                              style={{
                                width: 30,
                                height: 30,
                                maxWidth: 100,
                                maxHeight: 100,
                                backgroundColor: "#25d366",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 13,
                                fontWeight: "bold",
                                color: "#ffffff",
                              }}
                            >
                              {newComplaints.length}
                            </div>
                          )} */}
                      </div>
                      {roles.some((role) => role.id === viewUsers) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/users'> Users</Link>{" "}
                        </li>
                      )}
                      {roles.some((role) => role.id === viewAgents) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/agents'> Agents</Link>{" "}
                        </li>
                      )}
                      {roles.some((role) => role.id === viewGroups) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/user-groups'>
                            {" "}
                            Groups
                          </Link>{" "}
                        </li>
                      )}
                      {roles.some((role) => role.id === viewRoles) && (
                        <li>
                          {" "}
                          <Link to='/loggedin/admin/user-roles'>
                            {" "}
                            Roles
                          </Link>{" "}
                        </li>
                      )}
                    </ul>
                  </Accordion.Collapse>
                </li>
              </Accordion>
            </Accordion>
          </div>
        </div>
        <main className='body-content loggedIn-Home-Main'>
          {/* Navbar */}
          <nav className='navbar ms-navbar fixed-position'>
            <div
              className='ms-aside-toggler ms-toggler pl-0'
              data-target='#ms-side-nav'
              data-toggle='slideLeft'
              onClick={navToggle}
            >
              <div className='hide-harmburger-menu'>
                <span className='ms-toggler-bar bg-primary' />
                <span className='ms-toggler-bar bg-primary' />
                <span className='ms-toggler-bar bg-primary' />
              </div>
              <div>
                {toggle ? (
                  <i
                    className='fa fa-expand full-screen-icon'
                    aria-hidden='true'
                    style={{ color: "#0073e6", fontWeight: 700 }}
                    onClick={() => setToggle(false)}
                  />
                ) : (
                  <i
                    className='fa fa-compress'
                    aria-hidden='true'
                    style={{ color: "#0073e6", fontWeight: 700 }}
                    onClick={() => setToggle(true)}
                  />
                )}
              </div>
            </div>
            <div className='logo-sn logo-sm ms-d-block-sm'>
              <Link className='pl-0 ml-0 text-center navbar-brand mr-0' to=''>
                <img src={logo} alt='logo' />{" "}
              </Link>
            </div>
            <ul className='ms-nav-list ms-inline mb-0' id='ms-nav-options'>
              <Dropdown className='ms-nav-item ms-nav-user'>
                <Dropdown.Toggle
                  as={NavLink}
                  id='userDropdown'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                  className='p-0 toggle-icon-none'
                >
                  {" "}
                  <div className='d-flex'>
                    <div>
                      <span
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: 600,
                        }}
                        className='mr-2 mt-3'
                      >
                        Welcome, {user?.name}
                      </span>
                      <br />
                      <div className='d-flex justify-content-end'>
                        <span
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: 400,
                          }}
                          className='mr-4 mt-3'
                        >
                          {location[location.length - 1]?.name}
                        </span>
                      </div>
                    </div>
                    <img
                      className='ms-user-img ms-img-round float-right'
                      src={people5}
                      alt='people'
                      onClick={() => setShow(true)}
                    />
                  </div>
                </Dropdown.Toggle>
                {show ? (
                  <Dropdown.Menu
                    className='dropdown-menu-right user-dropdown'
                    aria-labelledby='userDropdown'
                  >
                    <li className='dropdown-divider' />
                    <li className='dropdown-menu-footer'>
                      <Link
                        className='media fs-14 p-2'
                        to='/loggedin/change-password'
                      >
                        <span onClick={() => setShow(false)}>
                          <i
                            className='fa fa-user mr-2'
                            style={{ fontSize: 20 }}
                          />{" "}
                          Change Password
                        </span>
                      </Link>
                    </li>
                    <li className='dropdown-menu-footer'>
                      <Link className='media fs-14 p-2' onClick={logout} to='/'>
                        <span>
                          <i className='flaticon-shut-down mr-2' /> Logout
                        </span>
                      </Link>
                    </li>
                  </Dropdown.Menu>
                ) : (
                  <></>
                )}
              </Dropdown>
            </ul>
            <div
              className='ms-toggler ms-d-block-sm pr-0 ms-nav-toggler'
              data-toggle='slideDown'
              data-target='#ms-nav-options'
            >
              <Dropdown className='ms-nav-item ms-nav-user'>
                <Dropdown.Toggle
                  as={NavLink}
                  id='userDropdown'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                  className='p-0 toggle-icon-none'
                >
                  {" "}
                  <img
                    className='ms-user-img ms-img-round float-right'
                    src={people5}
                    alt='people'
                  />{" "}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className='dropdown-menu-right user-dropdown'
                  aria-labelledby='userDropdown'
                >
                  <li className='dropdown-menu-header'>
                    <h6 className='dropdown-header ms-inline m-0'>
                      <span className='text-disabled'>
                        Welcome, {user?.name}
                      </span>
                      <br />
                      <span className=' mt-2'>
                        {location[location.length - 1]?.name}
                      </span>
                    </h6>
                  </li>
                  <li className='dropdown-divider' />
                  <li className='ms-dropdown-list'>
                    <Link
                      className='media fs-14 p-2'
                      to='/loggedin/change-password'
                    >
                      {" "}
                      <span>
                        <i className='flaticon-user mr-2' /> Change Password
                      </span>{" "}
                    </Link>
                  </li>
                  <li className='dropdown-divider' />

                  <li className='dropdown-menu-footer'>
                    <Link className='media fs-14 p-2' to='/'>
                      {" "}
                      <span>
                        <i className='flaticon-shut-down mr-2' /> Logout
                      </span>{" "}
                    </Link>
                  </li>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </nav>
          <div className='pt-1' style={{ marginTop: 80 }}>
            {children}
          </div>
          {/* <Outlet></Outlet> */}
        </main>
      </div>
    </div>
  );
}
